module.exports = __webpack_public_path__ + "static/img/line_blue.0bffc0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/UST/line_blue.png
// module id = 2cM8
// module chunks = 3